import React, { useEffect, useState } from 'react';
import { sp } from './sponsorApi';
import { Network, Plus, Send, Trash2, Loader2, Inbox } from 'lucide-react';

const KINDS = [{ v: 'OFFRE', l: 'Offre' }, { v: 'BESOIN', l: 'Besoin' }];

export default function ReseauTab() {
  const [mine, setMine] = useState([]);
  const [feed, setFeed] = useState([]);
  const [loading, setLoading] = useState(true);
  const [f, setF] = useState({ title: '', description: '', kind: 'OFFRE', branche: '' });
  const [msg, setMsg] = useState('');
  const [openInterests, setOpenInterests] = useState(null);
  const [interests, setInterests] = useState([]);

  const load = async () => {
    setLoading(true);
    try {
      const [m, r] = await Promise.all([sp.get('/opportunites/mes'), sp.get('/reseau')]);
      setMine(m.data.opportunites || []); setFeed(r.data.opportunites || []);
    } catch { /* noop */ } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const create = async () => {
    setMsg('');
    try { await sp.post('/opportunites', f); setF({ title: '', description: '', kind: 'OFFRE', branche: '' }); await load(); }
    catch (e) { setMsg(e?.response?.data?.detail || 'Échec.'); }
  };
  const publish = async (id) => { await sp.patch(`/opportunites/${id}/publier`, {}); await load(); };
  const remove = async (id) => { if (window.confirm('Supprimer ?')) { await sp.del(`/opportunites/${id}`); await load(); } };
  const interest = async (id) => {
    setMsg('');
    try { await sp.post(`/opportunites/${id}/interet`, { message: '' }); setMsg('Intérêt transmis.'); }
    catch (e) { setMsg(e?.response?.data?.detail || 'Échec.'); }
  };
  const viewInterests = async (id) => { setOpenInterests(id); const r = await sp.get(`/opportunites/${id}/interets`); setInterests(r.data.interets || []); };

  if (loading) return <div className="flex items-center gap-2 text-slate-400"><Loader2 className="w-5 h-5 animate-spin" /> Chargement…</div>;

  return (
    <div className="space-y-8" data-testid="reseau-tab">
      <section className="bg-slate-900 border border-slate-800 rounded-xl p-6">
        <div className="flex items-center gap-2 text-emerald-400 mb-4"><Plus className="w-5 h-5" /><h2 className="text-white font-semibold">Publier un besoin / une offre</h2></div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <select value={f.kind} onChange={(e) => setF({ ...f, kind: e.target.value })} data-testid="opp-kind-select" className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm">
            {KINDS.map((k) => <option key={k.v} value={k.v}>{k.l}</option>)}
          </select>
          <input value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} placeholder="Titre" data-testid="opp-title-input" className="md:col-span-2 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
          <input value={f.branche} onChange={(e) => setF({ ...f, branche: e.target.value })} placeholder="Filière (ex: BATICO)" data-testid="opp-branche-input" className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
          <textarea value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} placeholder="Description" data-testid="opp-desc-input" rows={2} className="md:col-span-4 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm" />
        </div>
        <button onClick={create} disabled={!f.title} data-testid="opp-create-btn" className="mt-3 bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 text-white text-sm font-semibold px-4 py-2 rounded-lg flex items-center gap-1"><Plus className="w-4 h-4" />Créer</button>
        {msg && <p className={`text-sm mt-2 ${/Échec|pouvez pas|invalide|introuvable/i.test(msg) ? 'text-amber-300' : 'text-emerald-400'}`} data-testid="opp-msg">{msg}</p>}

        <ul className="mt-5 space-y-2">
          {mine.length === 0 && <li className="text-slate-500 text-sm" data-testid="opp-mine-empty">Aucune publication.</li>}
          {mine.map((o) => (
            <li key={o.id} className="bg-slate-800/60 rounded-lg px-3 py-2 text-sm" data-testid={`opp-mine-${o.id}`}>
              <div className="flex items-center justify-between">
                <span className="text-white">{o.title} <span className="text-slate-500 text-xs">· {o.kind}{o.branche ? ` · ${o.branche}` : ''} · {o.status}</span></span>
                <div className="flex items-center gap-3">
                  {o.status !== 'PUBLISHED' && <button onClick={() => publish(o.id)} data-testid={`opp-publish-${o.id}`} className="text-emerald-400 text-xs">Publier</button>}
                  <button onClick={() => viewInterests(o.id)} data-testid={`opp-interests-${o.id}`} className="text-slate-300 text-xs flex items-center gap-1"><Inbox className="w-3 h-3" />Intérêts</button>
                  <button onClick={() => remove(o.id)} data-testid={`opp-delete-${o.id}`} className="text-red-400"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
              {openInterests === o.id && (
                <div className="mt-2 border-t border-slate-700 pt-2" data-testid={`opp-interestlist-${o.id}`}>
                  {interests.length === 0 && <p className="text-slate-500 text-xs">Aucun intérêt pour le moment.</p>}
                  {interests.map((it) => (<p key={it.id} className="text-slate-300 text-xs">{it.from_organisation} · {it.from_email}</p>))}
                </div>
              )}
            </li>
          ))}
        </ul>
      </section>

      <section className="bg-slate-900 border border-slate-800 rounded-xl p-6">
        <div className="flex items-center gap-2 text-emerald-400 mb-4"><Network className="w-5 h-5" /><h2 className="text-white font-semibold">Fil du réseau — opportunités des partenaires</h2></div>
        <ul className="space-y-2">
          {feed.length === 0 && <li className="text-slate-500 text-sm" data-testid="feed-empty">Aucune opportunité publiée.</li>}
          {feed.map((o) => (
            <li key={o.id} className="flex items-center justify-between bg-slate-800/60 rounded-lg px-3 py-2 text-sm" data-testid={`feed-${o.id}`}>
              <div>
                <span className="text-white">{o.title}</span>
                <span className="text-slate-500 ml-2 text-xs">{o.organisation} · {o.kind}{o.branche ? ` · ${o.branche}` : ''}</span>
                {o.description && <p className="text-slate-400 text-xs mt-0.5">{o.description}</p>}
              </div>
              {!o.is_mine && <button onClick={() => interest(o.id)} data-testid={`feed-interest-${o.id}`} className="text-emerald-400 hover:text-emerald-300 text-xs flex items-center gap-1"><Send className="w-3 h-3" />Je suis intéressé</button>}
              {o.is_mine && <span className="text-slate-600 text-xs">votre annonce</span>}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
